import React from 'react';
import { MarketButton, MarketButtonGroup, MarketDialog, MarketFooter, MarketHeader } from '@market/react';
import { getIntlString } from '@goparrot-dashboard/i18n';
import { DialogStateReturn } from './DialogStateReturn';

type Props = {
  dialog: DialogStateReturn;
  onCancel?: () => void;
  confirmButtonLabel?: string;
  handleConfirm: () => void;
  title?: string;
  dialogText?: string | JSX.Element;
  isConfirming?: boolean;
  icon?: JSX.Element;
  critical?: boolean;
};

export const MarketConfirmModal: React.FC<React.PropsWithChildren<Props>> = ({
  dialog,
  handleConfirm,
  onCancel,
  dialogText,
  title,
  isConfirming,
  confirmButtonLabel,
  icon,
  critical,
}) => {
  const { visible, dialogRef, dismiss } = dialog;

  const handleCancel = () => {
    dismiss();
    onCancel?.();
  };

  return visible ? (
    <MarketDialog onMarketDialogDismissed={handleCancel} ref={dialogRef} className="tw-overflow-visible">
      {icon}
      {title && (
        <MarketHeader>
          <h2 className="tw-mb-0">{title}</h2>
        </MarketHeader>
      )}
      {dialogText && (
        <section className="main">
          <p className="tw-mb-0">{dialogText}</p>
        </section>
      )}
      <MarketFooter>
        <MarketButtonGroup alignment="fill">
          <MarketButton variant={critical ? 'destructive' : 'regular'} rank="primary" onClick={handleConfirm} isLoading={isConfirming || undefined}>
            {confirmButtonLabel || getIntlString('button.confirm')}
          </MarketButton>
          <MarketButton variant={critical ? 'destructive' : 'regular'} rank="secondary" onClick={handleCancel}>
            {getIntlString('button.cancel')}
          </MarketButton>
        </MarketButtonGroup>
      </MarketFooter>
    </MarketDialog>
  ) : null;
};
